import { render, staticRenderFns } from "./trainingModulePageInformationImage3.vue?vue&type=template&id=cea3a54c&scoped=true&"
import script from "./trainingModulePageInformationImage3.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationImage3.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationImage3.vue?vue&type=style&index=0&id=cea3a54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea3a54c",
  null
  
)

export default component.exports